var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_vm.visible ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Ano/Série ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Ano/Série*",
      "counter": "25",
      "maxlength": "25",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 25);
      }]
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  }), _c('v-textarea', {
    attrs: {
      "label": "O que é esperado do aluno*",
      "counter": "2500",
      "maxlength": "2500",
      "rows": "4",
      "dense": "",
      "outlined": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 2500);
      }]
    },
    model: {
      value: _vm.content.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "descricao", $$v);
      },
      expression: "content.descricao"
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.modalidades,
      "label": "Modalidade de Ensino*",
      "outlined": "",
      "dense": "",
      "item-text": "nome",
      "return-object": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.modalidade,
      callback: function ($$v) {
        _vm.$set(_vm.content, "modalidade", $$v);
      },
      expression: "content.modalidade"
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.quantidadeBimestres,
      "label": "Quantidade de Bimestres*",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.quantidadeBimestres,
      callback: function ($$v) {
        _vm.$set(_vm.content, "quantidadeBimestres", $$v);
      },
      expression: "content.quantidadeBimestres"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Os campos marcados com asterisco(*) são obrigatórios.")])], 1)], 1), _c('sca-buttons', {
    attrs: {
      "actionText": _vm.edit ? 'Editar' : 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }